import React, { useEffect, useState } from 'react'
import { Formik, Form, ErrorMessage, Field } from "formik";
import { FixedSizeList as List } from 'react-window';
import styles from './postProject.module.css'
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
const cities = require("cities-list");






const PostProject = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const from = location.state?.from?.pathname || "/";

    const [id] = useState(4);
    const [drop] = useState(null);
    const [location_c, setlocation_c] = useState(null);//location when querying will be non specific ("location")
    const [project_size, setproject_size] = useState(null)
    const [size, setsize] = useState(null);
    const [location_r, setLocation_r] = useState(null);//here as well
    const [budget_l, setBudget_l] = useState(null);
    const [budget_h, setBudget_h] = useState(null);
    // const [duration_l, setDuration_l] = useState(null);
    const [duration_h, setDuration_h] = useState(null);
    const [exp, setexp] = useState(null);
    const [skill, setSkill] = useState(null);

//sector_r implies sector_p from post table

    console.log(drop)
    const initialValues = {
        company_name:null,
        size:null,
        sector:null,
        location_c:null,//location comapny
        company_desc:null,

        location_r:null,//location required
        budget_l:null,
        budget_h:null,
        duration_l:null,
        duration_h:null,
        exp:null,
        skill:null,
        project_desc:null,
        project_size:null,
        sector_r:null //sector required
    };

    const onSubmit = async (values) => {
        console.log("onSubmit", values);
        values.budget_l = budget_l;
        values.budget_h = budget_h;
        values.duration_l = duration_h;
        values.duration_h = duration_h;
        values.project_size = project_size;
        values.exp = exp;
        values.location_c = location_c;
        values.location_r = location_r;
        values.size = size;
        values.project_size = project_size;
        values.skill = skill;
        // console.log(size)
        console.log(values);

        await axios({
            method: 'put',
            url: `${process.env.REACT_APP_HOST1}/auth/update/true`,
            data: {company_name:values.company_name, size, location:location_c, company_desc:values.company_desc, sector:values.sector},
            headers: {
                "Content-Type": "application/json",
                "accessToken": localStorage.getItem("accessToken")
            }
        }).then((response) => {
            

            console.log("Response:", response.data);
            setTimeout(() => {
                
            }, 3000);
            axios({
                method: 'post',
                url: `${process.env.REACT_APP_HOST1}/post/create/true`,
                //sector project is sector required :P
                data: {location:location_r, sector_p:values.sector_r, budget_h,budget_l, duration_h, duration_l:duration_h, exp, skill, project_desc:values.project_desc, project_size},
                headers: {
                    "Content-Type": "application/json",
                    "accessToken": localStorage.getItem("accessToken")
                }
            }).then((response) => {
                
    
                console.log("Response:", response.data);
                
                navigate(from, { replace: true})
            }).catch((error) => {
                console.error("Error:", error);
            });
            // navigate(from, { replace: true})
        }).catch((error) => {
            console.error("Error:", error);
        });
    }
        // const validationSchema = Yup.object({
        //     password: Yup.string()
        //         .min(8, 'Password must be at least 8 characters')
        //         .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        //         .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        //         .matches(/[0-9]/, 'Password must contain at least one digit')
        //         .matches(/[@$!%*?&]/, 'Password must contain at least one special character')
        //         .required('Password is required'),
        //     name: Yup.string().required('Name is required'),
        //     cpassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
        // });
        // console.log(cities)



        return (
            <div className='h-[170dvh] flex flex-col items-center'>
                <Progress id={id} />
                <div className='h-fit w-[70%] transition-all duration-1000'>
                    <Formik
                        initialValues={initialValues}
                        onSubmit={onSubmit}
                        // validationSchema={validationSchema}
                    >
                        {() => (
                            <Form className='flex flex-col items-center'>
                                    <br/>
                                    <div className='flex flex-col w-full justify-evenly'>
                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%] w-full" name="company_name" placeholder="Company Name" />
                                        <ErrorMessage name="company_name" component="span" />
                                    <br/>
                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%] w-full" name="sector" placeholder="Sector" />
                                        <ErrorMessage name="sector" component="span" /> 
                                    </div>
                                    <br/>
                                    <div className='flex flex-row justify-between w-full'>
                                    <SearchDrop placeholder={"Company Location"} setFunction={setlocation_c} />    
                                    <SimpleDropdown options={{S:"Small 0-9 Employees", M:"Medium 9-100 Employees",L:"Large 100+ Employees"}} label={"Company Size"} width={40} setFunction={setsize} />
                                    </div>
                                    <br/>
                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%] w-full" name="company_desc" placeholder="Company Description" />
                                        <ErrorMessage name="company_desc" component="span" />
                                    <br/>
                                    <br/>
                                    <SliderComponent setFunction={{setBudget_h,setBudget_l}} width={10} />
                                    <br />
                                    <SimpleDropdown label={"Duration of Project"} options={{6:"Less than 6 months", 12:"12 months", 18:"18 months", 24:"24 months",25:"More than 2 years", 0:"No prefrence"}} width={100} setFunction={setDuration_h}/>
                                    <br/>
                                    <SimpleDropdown label={"Minimum Experience"} options={{1:"1 year",2:"2 years", 3:"3 years",5:"5 years",10:"10+ years"}} width={100} setFunction={setexp}/>
                                    <br/>
                                    <SearchDropSelect skills={["Measurement and Metrology","Quality Control and Inspection","GD&T", "CNC "]} setFunction={setSkill} />
                                    <br />
                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%] w-full" name="project_desc" placeholder="Project Description" />
                                        <ErrorMessage name="project_desc" component="span" />
                                    <br/>
                                    <div className='w-full flex justify-between'>
                                    <SearchDrop placeholder={"Project Location"} setFunction={setLocation_r}/> 
                                    <SimpleDropdown options={{S:"Small scale", M:"Medium scale",L:"Large scale"}} label={"Project Size"} width={40} setFunction={setproject_size}/>             
                                    </div>

                                    <br/>
                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%] w-full" name="sector_r" placeholder="Looking in which sector ?" />
                                        <ErrorMessage name="sector_r" component="span" />
                                    <br/>


{/* 
                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%]" name="location_c" placeholder="location" />
                                        <ErrorMessage name="location_c" component="span" />

                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%]" name="location_r" placeholder="location" />

                                        <ErrorMessage name="location_r" component="span" /> */}
                                    {/* <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%]" name="budget_l" placeholder="budget" />
                                        <ErrorMessage name="budget_l" component="span" />

                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%]" name="budget_h" placeholder="budget" />
                                        <ErrorMessage name="budget_h" component="span" />

                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%]" name="duration_l" placeholder="duration" />
                                        <ErrorMessage name="duration_l" component="span" />

                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%]" name="duration_h" placeholder="duration" />
                                        <ErrorMessage name="duration_h" component="span" /> */}

                                    {/* <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%]" name="exp" placeholder="e" />
                                        <ErrorMessage name="exp" component="span" />

                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%]" name="skill" placeholder="ski" />
                                        <ErrorMessage name="skill" component="span" />

                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%]" name="project_desc" placeholder="project_de" />
                                        <ErrorMessage name="project_desc" component="span" />



                                    <Field className="text-sm border-2 outline-none rounded-md text-gray-400 p-[1%]" name="project_size" placeholder="project_si" />
                                        <ErrorMessage name="project_size" component="span" />
                                        <br/> */}

                                <button className='p-2 px-4 bg-[#03236F] w-fit h-fit rounded-lg text-white' type="submit">Post</button>



                            </Form>
                        )}

                    </Formik>



                </div>
            </div>
        )

    }

    

    function Progress(id) {
        id = id.id;
        return <ul className='flex flex-row justify-center items-center w-[50%]'>
            <li className={` border-[3px] rounded-full py-[0.6rem] px-[1.27rem] ${id === 1 ? 'bg-[#03236F] text-white  border-[#03236F]' : 'border-gray-500'}`}>1</li>
            <svg className='w-[100%] mx-[5%]' width="100" height="100">
                <line x1="0" y1="50" x2="300" y2="50" stroke="gray" strokeWidth="2" />
            </svg>
            <li className={`border-[3px] rounded-full py-[0.6rem] px-[1.27rem] ${id === 2 ? 'bg-[#03236F] text-white  border-[#03236F]' : 'border-gray-500'}`}>2</li>
            <svg className='w-[100%] mx-[5%]' width="100" height="100">
                <line x1="0" y1="50" x2="300" y2="50" stroke="gray" strokeWidth="2" />
            </svg>
            <li className={` border-[3px] rounded-full py-[0.6rem] px-[1.27rem] ${id === 3 ? 'bg-[#03236F] text-white  border-[#03236F]' : 'border-gray-500'}`}>3</li>
            <svg className='w-[100%] mx-[5%]' width="100" height="100">
                <line x1="0" y1="50" x2="300" y2="50" stroke="gray" strokeWidth="2" />
            </svg>
            <li className={` border-[3px] rounded-full py-[0.6rem] px-[1.27rem] ${id === 4 ? 'bg-[#03236F] text-white  border-[#03236F]' : 'border-gray-500'}`}>4</li>
        </ul>;
    }
export default PostProject;

export function SliderComponent({setFunction, width}) {
    const [sliderValue, setSliderValue] = useState(51); // Initial value of slider
    const [slider2Value, setSlider2Value] = useState(50);

    useEffect(() => {

            setFunction.setBudget_h(sliderValue);
            setFunction.setBudget_l(slider2Value);
            // console.log(setFunction)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sliderValue,slider2Value])

    const handleSliderChange = (event) => {
        let value = parseInt(event.target.value); // Convert to integer

        if (value < slider2Value) {
            value = slider2Value; // Ensure value doesn't go below min
        } 

        setSliderValue(value); // Update slider value in state
    };
    const handleSliderChange2 = (event) => {
        let value = parseInt(event.target.value); // Convert to integer
        if (value > sliderValue) {
            value = sliderValue; // Ensure value doesn't go below min
        }

        setSlider2Value(value); // Update slider value in state
    };
    return (      
        <div className='relative h-[10rem] w-full border-2 outline-none rounded-3xl text-gray-400'>
        <input className={`${styles.slider1} ${styles.slider}`} style={{top: '0'}} min="0" max="100" value={sliderValue} onChange={handleSliderChange} type="range" step="10" name="" />
        <div className='h-full w-full flex items-end justify-center absolute'>
            <hr className='absolute top-[50%] bottom-[50%] bg-gray-200 w-[80%] mt-1 h-1' />
            <div className='w-full z-10 flex justify-center gap-[5%]'><input value={slider2Value} autoFocus onChange={(e)=>setSlider2Value(e.target.value)} className={`mb-[1%] border-2 outline-none rounded-xl text-gray-400 p-1 text-center appearance-none`} style={{width: `${width}%`}} type="number" placeholder='Min'/> <input value={sliderValue} autoFocus onChange={(e)=>setSliderValue(e.target.value)} className={`mb-[1%] border-2 outline-none rounded-xl text-gray-400 p-1 text-center`} style={{width: `${width}%`}} type="number" placeholder='Max'/></div>
        </div>
        <input className={`${styles.slider}`} style={{bottom: '0'}}  min="0" max="100" value={slider2Value} onChange={handleSliderChange2} type="range" step="10" name="" />
        </div>

    )
}

export function SearchDrop({ placeholder , setFunction, width=40 }) {
    const [searchTerm, setSearchTerm] = useState('');
    const [dropHide, setDropHide] = useState(true);
    useEffect(() => {

            setFunction(searchTerm);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm])

      
    const filteredItems = Object.keys(cities).filter(item =>
      item.toLowerCase().startsWith(searchTerm.toLowerCase())
    );

    return(
        <div className={`border-2 h-fit rounded-lg py-1`} style={{width: `${width}%`}} onFocus={()=>setDropHide(false)} onBlur={()=>setDropHide(true)}>
        <SearchBar searchTerm={searchTerm} onSearchChange={setSearchTerm} placeholder={placeholder} />
        {!dropHide && <VirtualizedList  items={filteredItems} setSearchTerm={setSearchTerm} setFunction={setFunction}  />}
        </div>
    )
}



const Row = ({ index, data }) => (
    <div className='text-sm text-gray-400 cursor-pointer hover:bg-gray-100' style={{scrollbarWidth: '12px'}} onMouseDown={()=>data.setSearchTerm(data.items[index])}>
      {data.items[index]}
    </div>
  );

  const SearchBar = ({ searchTerm, onSearchChange, placeholder }) => {
    return (
      <input
        className='outline-none text-gray-400 px-3 text-sm w-full'
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={e => onSearchChange(e.target.value)}
      />
    );
  };

  const VirtualizedList = ({ items, setSearchTerm }) => {
    const itemSize = 35; // Height of each list item in pixels
    const listHeight = 100; // Height of the list container
  
    return (
      <List
        height={listHeight}
        itemCount={4}
        itemSize={itemSize}
        width="100%"
        itemData={{items, setSearchTerm}}
        className={styles.scroll}
      >
        {Row}
      </List>
    );
  };
  
//searchTerm array is filtering for input while Selection array is filtering for selected, after dropdown is selected it adds to Selection and subtracts from searchterms
export function SearchDropSelect({skills=["Measurement and Metrology","Quality Control and Inspection","GD&T", "CNC "], setFunction}) {
    const [searchTerm, setSearchTerm] = useState(skills);    
    const [dropHide, setDropHide] = useState(true);
    const [Selection, setSelection] = useState([])
    useEffect(() => {

            setFunction(Selection)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Selection])


      const handleChange = (e) => {
        const filteredItems = skills.filter(value => !Selection.includes(value)).filter(item =>
            item.toLowerCase().includes(e.target.value.toLowerCase())
          );
        setSearchTerm(filteredItems);

      };
      //add searchterm/s with params
function Remove(param) {
        setSearchTerm([...searchTerm,param]);
        setSelection(Selection.filter(items => items !== param))
        // console.log("hi")

      };
      

    return(
        <>
        <div className='border-2 h-fit outline-none rounded-md text-gray-400 w-full text-start' onFocus={()=>setDropHide(false)}>
    <input className='outline-none p-2 w-full text-sm' type="text" onChange={handleChange} name="" id="" placeholder='Skills'/>
    {!dropHide && <div  className={`${styles.scroll} overflow-y-scroll h-[3rem]`}>
        { searchTerm.map((params,index)=> <li className='list-none hover:bg-gray-200 cursor-pointer px-2 text-sm' key={index} value={params} onClick={()=>{setSelection([...Selection,params]); setSearchTerm(searchTerm.filter(items=>items !== params))}}>{params}</li>)}
    </div>}
    </div>
    <br/>
    <div className='flex flex-wrap gap-[5%]'>
            {Selection.map((param,index)=><div className='border-2 outline-none rounded-md text-gray-400 px-4 mx-1 cursor-pointer flex flex-row items-center' key={index} value={param} onMouseDown={()=>Remove(param)}>{param}
            <svg className='rotate-45 opacity-40 my-auto' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <line x1="5" y1="12" x2="19" y2="12" stroke="gray" strokeWidth="1" />
                <line x1="12" y1="5" x2="12" y2="19" stroke="gray" strokeWidth="1" />
                </svg>
            </div>)}
    </div>

        </>
    )
}

export const SimpleDropdown = ({ options,width,label, setFunction }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    console.log(options)

    useEffect(() => {
        console.log(width)

            setFunction(selectedOption);
            console.log(selectedOption)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOption])

    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };
  
    const handleOptionClick = (option) => {
      setSelectedOption(option);
      setIsOpen(false); // Close the dropdown after selecting an option
    };
  
    return (
      <div className={`dropdown border-2 outline-none rounded-md text-gray-400  text-start h-fit py-1`} style={{width: `${width}%`}}>
        <button type='button' className="dropdown-toggle text-gray-400 text-sm text-start p-[1%] px-3 w-full outline-none" onMouseDown={()=>toggleDropdown()}>
          {selectedOption ? options[selectedOption] : label}
        </button>
        {isOpen && 

            Object.keys(options).map((option,index) => (
              <div className='text-start text-sm cursor-pointer hover:bg-gray-100 w-full p-[1%] px-3' key={index} onMouseDown={() => handleOptionClick(option)}>
                {options[option]}
              </div>
            ))

        }
      </div>
    );
  };

